import { ApplicationConfig, importProvidersFrom, inject, provideAppInitializer, provideZoneChangeDetection } from '@angular/core';
import { provideRouter } from '@angular/router';
import { HttpClient, provideHttpClient, withInterceptors } from '@angular/common/http';
import { routes } from './app.routes';
import { tokenInterceptor } from './core/interceptors/token.interceptor';
import { LoggerModule } from 'ngx-logger';
import { DatePipe } from '@angular/common';
import { errorInterceptor } from './core/interceptors/error.interceptor';
import { provideToastr } from 'ngx-toastr';
import { BrowserAnimationsModule, provideAnimations } from '@angular/platform-browser/animations';
import { provideTranslateService, TranslateLoader } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { performanceInterceptor } from './core/interceptors/performance.interceptor';
import { loadingInterceptor } from './core/interceptors/loading.interceptor';
import { provideSpinnerConfig } from 'ngx-spinner';
import { BrowserModule } from '@angular/platform-browser';
import { timeoutInterceptor } from './core/interceptors/timeout.interceptor';
import { environment } from '../environments/environment';
import { ModalModule } from 'ngx-bootstrap/modal';
import { initializeApp, provideFirebaseApp } from '@angular/fire/app';
import { getAuth, provideAuth } from '@angular/fire/auth';
import { ConfigurationService } from './core/services/configuration/configuration.service';


const httpLoaderFactory: (http: HttpClient) => TranslateHttpLoader = (
  http: HttpClient
) => new TranslateHttpLoader(http, './i18n/', '.json');

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes),
    provideHttpClient(),
    provideHttpClient(
      withInterceptors([
        tokenInterceptor,
        errorInterceptor,
        performanceInterceptor,
        loadingInterceptor,
        timeoutInterceptor,
      ])
    ),
    importProvidersFrom([
      BrowserModule,
      BrowserAnimationsModule,
      ModalModule.forRoot(),
      LoggerModule.forRoot({
        level: environment.DV_LOGGER_LEVEL,
        timestampFormat: environment.DV_LOGGER_TIMESTAMP_FORMAT,
        disableFileDetails: true,
        colorScheme: [
          '#5688e3',
          'green',
          '#f09c43',
          '#659e4c',
          '#f7c04a',
          '#f53d3d',
          '#f7f5f5',
        ],
      }),
    ]),
    ConfigurationService,
    provideAppInitializer(() => {
      const configService = inject(ConfigurationService);
      return configService.loadConfig();
    }),
    provideSpinnerConfig({ type: 'ball-scale-multiple' }),
    provideAnimations(),
    provideToastr({
      timeOut: 5000,
      positionClass: 'toast-top-full-width',
      preventDuplicates: true,
      progressBar: true,
    }),
    provideTranslateService({
      loader: {
        provide: TranslateLoader,
        useFactory: httpLoaderFactory,
        deps: [HttpClient],
      },
    }),
    DatePipe,
    provideFirebaseApp(() => initializeApp(environment.firebase)),
    provideAuth(() => getAuth()),
  ],
};
